export default __webpack_public_path__ + "static/actuamos-4effc560e7d6f424bccd08611cdcffba.png";